export default __webpack_public_path__ + "static/media/bnb_grey.29594806.png";